export default __webpack_public_path__ + "static/media/Retirement.7081fbbc.png";